import { CargaDeTrabalhoScreen } from "@/screens/recursos/carga-de-trabalho";

/** Thin wrapper — toda lógica fica em screens/recursos/carga-de-trabalho */
export function CargaDeTrabalhoPage() {
  return <CargaDeTrabalhoScreen />;
}
